import { render } from "./ProfileInfoLoader.vue?vue&type=template&id=01f05168"
import script from "./ProfileInfoLoader.vue?vue&type=script&lang=js"
export * from "./ProfileInfoLoader.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/zaytoon-sudani-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__